module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/franchising/hero-mobile.4881dd781ae309ec4a8e5ee958f07de6.jpg";